import VueCookies from 'vue-cookies';

const isDocplePlusSubdomain = () => {
  if (typeof window === 'undefined') return false;
  const { hostname } = window.location;
  return hostname.endsWith('.docple-plus.com') || hostname.endsWith('.dev-docple-plus.com');
};

const getCookieDomain = () => {
  if (!isDocplePlusSubdomain()) return undefined;
  return window.location.hostname.endsWith('.dev-docple-plus.com') ? '.dev-docple-plus.com' : '.docple-plus.com';
};

/**
 * 쿠키를 설정하는 유틸 함수
 * @param {string} key - 쿠키 키
 * @param {string|boolean|object} value - 쿠키 값
 * @param {string|number|object} expires - 만료 시간 (문자열, 숫자, 또는 객체)
 */
export const setCookie = (key, value, expires) => {
  const cookieOptions = {
    path: '/',
    ...(typeof expires === 'object' ? expires : { expires }),
  };

  const domain = getCookieDomain();
  if (domain) {
    cookieOptions.domain = domain;
  }

  VueCookies.set(key, value, cookieOptions);
};

/**
 * 쿠키를 가져오는 유틸 함수
 * @param {string} key - 쿠키 키
 * @returns {any} 쿠키 값
 */
export const getCookie = key => {
  return VueCookies.get(key);
};

/**
 * 쿠키를 삭제하는 유틸 함수
 * @param {string} key - 쿠키 키
 * @param {object} options - 쿠키 옵션
 */
export const removeCookie = (key, options = {}) => {
  const cookieOptions = {
    path: '/',
    ...options,
  };

  const domain = getCookieDomain();
  if (domain) {
    cookieOptions.domain = domain;
  }

  VueCookies.remove(key, cookieOptions);
};

export default {
  setCookie,
  getCookie,
  removeCookie,
};
